<template>
  <div class="search-bar">
    <standard-input
      :value="filter"
      type="search"
      label="Miasto, adres lub nazwa PS"
      :icon="true"
      @input_change="onInput($event)"
    >
      <svg svg-inline="" class="input-label-icon" role="presentation" focusable="false" width="48" height="48" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"><path d="M42 42L29 29l13 13zm-9.5-22c0 7.6-5.7 12.5-12.5 12.5-6.9 0-12.5-5.6-12.5-12.5S13.1 7.5 20 7.5 32.5 13.1 32.5 20z" stroke="currentColor" fill="none"/></svg>
    </standard-input>
  </div>
</template>

<script>
import StandardInput from '~/StandardInput';
import { mapGetters, mapActions } from 'vuex';
import { debounce } from 'lodash';

export default {
  components: {
    StandardInput,
  },
  data() {
    return {
      filter: '',
    };
  },
  computed: {
    ...mapGetters({
      serviceStations: 'serviceStations/getServiceStations',
    }),
  },
  methods: {
    ...mapActions({
      filterServiceStations: 'serviceStations/filterServiceStations',
    }),
    // eslint-disable-next-line
    debounceFilter: debounce(function () {
      this.filterServiceStations(this.filter);
    }, 500),
    onInput(value) {
      this.filter = value;
      this.debounceFilter();
    },
  },
  mounted() {
    this.filterServiceStations(this.filter);
  },
};
</script>
